var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-card"},[_c('h3',{staticClass:"popup-card__header"},[_vm._t("card-header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }